import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import CustomValidators, { isNewPwdValidator, pwdValidator } from 'src/app/core/models/custom-validators.model';
import { PasswordRecoveryService } from '../../../services/password-recovery.service';
import { Subscription } from 'rxjs';
import { NotificationComponent } from 'src/app/modules/shared/components/notification/notification.component';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslocoService } from '@ngneat/transloco';
import { ErrorCodesEnum } from 'src/app/core/shared/enums/errorCodesEnum';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-change-password-by-password.dialog',
  styleUrls: ['change-password-by-password.dialog.component.scss'],
  templateUrl: 'change-password-by-password.dialog.component.html',
})
export class ChangePasswordByPasswordDialogComponent {
  @ViewChild('notification') notification!: NotificationComponent;
  private subs: Subscription = new Subscription();
  pwdFocusState = false;
  isHideCurrentPwd = true;
  isHidePwd = true;
  isHideVerifyPwd = true;
  isComplete = false;

  pwdForm: FormGroup = this.fb.group(
    {
      currentPassword: ['', Validators.required],
      password: [
        '',
        {
          validators: [
            Validators.required,
            CustomValidators.pwdLength,
            CustomValidators.pwdNumbers,
            CustomValidators.pwdSymbol,
            CustomValidators.pwdLowercase,
            CustomValidators.pwdUppercase,
          ],
        },
      ],
      verifyPwd: ['', Validators.required],
    },
    { validators: [pwdValidator, isNewPwdValidator] }
  );

  constructor(
    private dialogRef: MatDialogRef<ChangePasswordByPasswordDialogComponent>,
    private fb: FormBuilder,
    private passwordRecoveryService: PasswordRecoveryService,
    private translocoService: TranslocoService
  ) {}

  OnSubmit() {
    this.notification.hide();
    this.subs.add(
      this.passwordRecoveryService.changePasswordByPassword(this.pwdForm.value).subscribe(
        (isOk: boolean) => {
          this.isComplete = true;
          this.notification?.showSuccess(this.translocoService.translate('restorePwd.changeSuccess'));
        },
        (err: HttpErrorResponse) => {
          if (err.error.title as ErrorCodesEnum) {
            //TODO расширить список ошибок
            this.notification.showError(this.translocoService.translate('errorCodes.' + err.error.title));
          } else this.notification.showError(this.translocoService.translate('server-error.error'));
        }
      )
    );
  }
  onCloseClick() {
    this.dialogRef.close(this.isComplete);
  }
}
